import { render, staticRenderFns } from "./page.vue?vue&type=template&id=c5f28aa2&"
import script from "./page.vue?vue&type=script&lang=js&"
export * from "./page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5f28aa2')) {
      api.createRecord('c5f28aa2', component.options)
    } else {
      api.reload('c5f28aa2', component.options)
    }
    module.hot.accept("./page.vue?vue&type=template&id=c5f28aa2&", function () {
      api.rerender('c5f28aa2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/page.vue"
export default component.exports